/** Підписи та стилі статусів поставки (incoming_shipments.status). */

/** Порядок опцій у селекті ручної зміни статусу. */
export const SHIPMENT_STATUS_SELECT_ORDER = [
  'draft',
  'awaiting_matching',
  'ready_for_scan',
  'scanning',
  'reconciliation_needed',
  'ready_to_post',
  'partially_posted',
  'posted'
];

export const SHIPMENT_STATUS_LABELS = {
  draft: 'Чернетка',
  awaiting_matching: 'Потребує співставлення',
  ready_for_scan: 'Готово до сканування',
  scanning: 'В процесі приймання',
  reconciliation_needed: 'Є розбіжності',
  ready_to_post: 'Готово до оприбуткування',
  partially_posted: 'Частково викладено на сайт',
  posted: 'Викладено на сайт'
};

const SHIPMENT_STATUS_BADGE = {
  draft: 'badge-secondary',
  awaiting_matching: 'badge-warning text-dark',
  ready_for_scan: 'badge-info',
  scanning: 'badge-primary',
  reconciliation_needed: 'badge-danger',
  ready_to_post: 'badge-success',
  partially_posted: 'badge-info',
  posted: 'badge-dark'
};

export function shipmentStatusLabel(status) {
  if (!status) return '—';
  return SHIPMENT_STATUS_LABELS[status] || status;
}

export function shipmentStatusBadgeClass(status) {
  if (!status) return 'badge badge-light text-muted';
  return `badge ${SHIPMENT_STATUS_BADGE[status] || 'badge-light'}`;
}


/** Keep unknown historical statuses selectable until the user changes them. */
export function shipmentStatusOptions(current = 'draft') {
  return current && !SHIPMENT_STATUS_SELECT_ORDER.includes(current)
    ? [current, ...SHIPMENT_STATUS_SELECT_ORDER]
    : SHIPMENT_STATUS_SELECT_ORDER;
}
